import { render } from "./AddOtherPlayerSelection.vue?vue&type=template&id=2c7d5a62"
import script from "./AddOtherPlayerSelection.vue?vue&type=script&lang=js"
export * from "./AddOtherPlayerSelection.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__